var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 38,
    stroke: "#393939",
    strokeWidth: 5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 50 Q33.5 35 50 50 Q66.5 65 83 50 A33 33 0 0 1 17 50",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "M17 50 Q33.5 35 50 50 Q66.5 65 83 50 A33 33 0 0 1 17 50;M17 50 Q33.5 65 50 50 Q66.5 35 83 50 A33 33 0 0 1 17 50;M17 50 Q33.5 35 50 50 Q66.5 65 83 50 A33 33 0 0 1 17 50",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.e56722f6.svg";
export { ForwardRef as ReactComponent };